/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getProjectImgAndShareIcon } from 'utils/projectHelpers';
import { useTranslation } from 'react-i18next';
import { getProjects } from 'app/routes/Dashboard/actions/projects';
import allProjectIcon from 'assets/images/all-projects.jpg';

const PollImageProjects = ({ onSelectProject }) => {
  const { t } = useTranslation();
  const projectsObj = useSelector(state => state.projects);
  const allProjects = Object.values(projectsObj || {});

  const totalLikiees = useSelector(state => state.home?.totalLikiees);

  const allLikiessProject = {
    isAllItems: true,
    name: t('text_all_likiees'),
    itemsCount: totalLikiees || 0,
    icon: allProjectIcon,
  };

  const projects = [allLikiessProject, ...allProjects];

  useEffect(() => {
    if (!projectsObj) getProjects();
  }, []);

  return (
    <div className='project'>
      {projects &&
        projects.map((item, index) => {
          const { Icon, image } = getProjectImgAndShareIcon(item);

          if (!item.isAllItems && !item.itemsCount) return null;
          return (
            <div key={index} className='d-flex mb-10  align-items-center justify-content-between'>
              <div className='d-flex align-items-center cursor-pointer' onClick={() => onSelectProject(item)}>
                <img width='60' className='rounded-6 mr-8' height='60' src={image} alt={item.name} />
                {item.name}
              </div>
              {Icon && <Icon />}
            </div>
          );
        })}
    </div>
  );
};

export default PollImageProjects;
